import React, { PureComponent } from 'react'

import Badge from '../../../../UniformComponents/Badge'

class CustomTagGroup extends PureComponent {
    levelLabel = (oid) => {
        const { store } = this.props
        return store.getLevels()
            .filter(({ value }) => value === oid)
            .map(({ label }) => label)
    }

    render() {
        const { group, onEdit, onDelete } = this.props
        const { name, tags, cascade } = group

        return (
            <div className="customTagGroup">
                <div className="customTagGroupHeader">
                    <div className="customTagGroupHeading">
                        <i className="fa-light fa-tags" />
                        <span className="title">{name}</span>
                        <Badge
                            label={cascade ? 'cascading' : 'not cascading'}
                            type={cascade ? 'success' : 'error'}
                            isRounded
                        />
                    </div>
                    <div style={{ display: 'flex', flex: 1, justifyContent: 'end' }}>
                        <span style={{ fontSize: '11px' }}>last updated: {group.lastUpdatedAt}</span>
                    </div>
                    {(onEdit || onDelete) && (
                        <div className="customTagGroupActions">
                            {onEdit && (
                                <button type="button" className="editButton" onClick={onEdit}>
                                    <i className="fa-light fa-pen-to-square" />
                                    <span>Edit</span>
                                </button>
                            )}
                            {onDelete && (
                                <button type="button" className="deleteButton" onClick={onDelete}>
                                    <i className="fa-light fa-trash-can" />
                                </button>
                            )}
                        </div>
                    )}
                </div>
                <div className="customTagGroupBody">
                    <table>
                        <thead>
                            <tr>
                                <th className="col-id">id</th>
                                <th>Name</th>
                                <th>Level</th>
                                <th>Client</th>
                                <th>Industry</th>
                                <th>Event type</th>
                                <th>Survey type</th>
                                <th>Respondent type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tags.map((tag) => (
                                <tr key={tag.id}>
                                    <td className="col-id">{tag.id}</td>
                                    <td>{tag.name}</td>
                                    <td>{this.levelLabel(tag.oid)}</td>
                                    <td>{tag.clientId}</td>
                                    <td>{tag.industry}</td>
                                    <td>{tag.productType}</td>
                                    <td>{tag.surveyType}</td>
                                    <td>{tag.respondentType}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default CustomTagGroup
